const SELECTED_LOCATION_STORAGE_KEY = "teresasPizzaUserSelectedFranchise";
const SELECTED_LOCATION_COOKIE_NAME = "teresasPizzaSelectedLocationId";

function safeJsonParse(value, fallback = null) {
	if (!value) {
		return fallback;
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		console.error("Failed to parse JSON payload", error);
		return fallback;
	}
}

function setSelectedLocationCookie(locationId) {
	if (!locationId) {
		document.cookie = `${SELECTED_LOCATION_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
		return;
	}

	document.cookie = `${SELECTED_LOCATION_COOKIE_NAME}=${encodeURIComponent(locationId)}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;
}

export function getSelectedLocation() {
	const selectedLocation = window.localStorage.getItem(
		SELECTED_LOCATION_STORAGE_KEY,
	);
	const parsedLocation = safeJsonParse(selectedLocation);

	if (selectedLocation && !parsedLocation) {
		window.localStorage.removeItem(SELECTED_LOCATION_STORAGE_KEY);
		setSelectedLocationCookie(null);
	}

	return parsedLocation;
}

export function setSelectedLocation(location) {
	if (!location) {
		window.localStorage.removeItem(SELECTED_LOCATION_STORAGE_KEY);
		setSelectedLocationCookie(null);
		return;
	}

	window.localStorage.setItem(
		SELECTED_LOCATION_STORAGE_KEY,
		JSON.stringify(location),
	);
	setSelectedLocationCookie(location.id);
}

export function updateLocationSelector() {
	const locationSelectorText = document.querySelector(
		".location-selector-text",
	);
	if (!locationSelectorText) {
		return;
	}

	const selectedLocation = getSelectedLocation();
	locationSelectorText.textContent = selectedLocation
		? selectedLocation.name
		: "Find a restaurant";
}
